import DOMPurify from 'dompurify';

/**
 * Sanitizes backend / tenant-authored HTML (job descriptions, privacy policy, terms) before it
 * is injected with dangerouslySetInnerHTML. Flutter renders this HTML with HtmlWidget
 * (html_text_widget.dart), which never runs scripts or event handlers; DOMPurify strips those
 * and keeps the markup. Links keep their `target`, and new-tab links get rel="noopener noreferrer".
 */
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
}
